import CloudinaryReportDrawerFilterMain from "./cloudinary-report-filter-main-drawer";


const CloudinaryReportDrawers = {
    FilterMain: CloudinaryReportDrawerFilterMain
}

export default CloudinaryReportDrawers;